import env from '../config/env';
import { assignHref, getHref } from './location';
import { CONTACT_US_WELCOME } from './redirectLinks';

const redirectToLogin = (): void => {
  assignHref(`${env.LOGIN_URL}?origin=${getHref()}`);
};

const redirectToDashboard = (): void => {
  assignHref(`${env.SITE_URL}`);
};

const redirectToTrialCancel = (): void => {
  assignHref(`${env.SITE_URL}/trial-cancel-subscription`);
};

const redirectToContactUsWelcome = (): void => {
  assignHref(CONTACT_US_WELCOME);
};

export { redirectToLogin, redirectToDashboard, redirectToTrialCancel, redirectToContactUsWelcome };
